import { Component } from '@angular/core';
import { Platform, NavController, NavParams } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';

import { LoginPage } from '../login/login';
import { RegisterPage } from '../register/register';

@Component({
  selector: 'page-prelogin',
  templateUrl: 'prelogin.html',
})
export class PreloginPage {

	constructor(
		platform: Platform, 
		public statusBar: StatusBar, 
		public navCtrl: NavController, 
		public navParams: NavParams) {
		this.statusBar.styleLightContent();   
	}

	ionViewDidLoad() {
		this.statusBar.styleLightContent();   
	}
	
	ionViewWillEnter() {
		this.statusBar.styleLightContent();   
	}

	gotoPage(page){
		switch (page) {
		  case "Login":
		    this.navCtrl.push(LoginPage);    
		    break;
		  case "Register":
		    this.navCtrl.push(RegisterPage);    
		    break
		}   
	} 
}



// WEBPACK FOOTER //
// ./src/pages/prelogin/prelogin.ts